// src/lib/kinema/devtools/LayerTreePanel.tsx
import { useLayerTree, useSelection, useEditor } from '../konva/hooks';
import { SELECT_LAYER } from '../core/commands/commands';
import type { BaseLayerData } from '../core/types';

function LayerNode({ layer, depth, getChildren }: {
  layer: BaseLayerData; depth: number;
  getChildren: (id: string) => BaseLayerData[];
}) {
  const editor = useEditor();
  const { selectedIds } = useSelection();
  const children = getChildren(layer.id);
  const isSelected = selectedIds.has(layer.id);

  return (
    <div style={{ paddingLeft: depth * 16 }}>
      <div
        onClick={() => editor.dispatchCommand(SELECT_LAYER, { layerId: layer.id })}
        style={{
          padding: '2px 4px',
          fontFamily: 'monospace',
          fontSize: 12,
          cursor: 'pointer',
          background: isSelected ? '#eff6ff' : 'transparent',
          color: isSelected ? '#1e40af' : '#334155',
          borderRadius: 3,
        }}
      >
        {children.length > 0 ? '\u25BC ' : '\u2022 '}
        <span style={{ color: '#3b82f6' }}>{layer.type}</span>
        {' '}<span>"{layer.name}"</span>
        {layer.locked && <span style={{ color: '#94a3b8' }}> [locked]</span>}
        {!layer.visible && <span style={{ color: '#94a3b8' }}> [hidden]</span>}
      </div>
      {children.map((child) => (
        <LayerNode key={child.id} layer={child} depth={depth + 1} getChildren={getChildren} />
      ))}
    </div>
  );
}

export function LayerTreePanel() {
  const { roots, getChildren } = useLayerTree();
  return (
    <div style={{ padding: 8, fontSize: 12, color: '#334155', background: '#ffffff', height: '100%' }}>
      {roots.length === 0 && <div style={{ color: '#94a3b8' }}>No layers</div>}
      {roots.map((layer) => (
        <LayerNode key={layer.id} layer={layer} depth={0} getChildren={getChildren} />
      ))}
    </div>
  );
}
